document.addEventListener('DOMContentLoaded', function () {
  // Judge.me Write Review - Modal બંધ, Inline form show
  var observer = new MutationObserver(function () {
    var modal = document.querySelector('.jdgm-modal__background');
    if (modal && modal.style.display !== 'none') {
      // Modal આવે ત્યારે તરત બંધ કરો
      modal.style.cssText = 'display:none !important;';
      
      var modalContent = document.querySelector('.jdgm-modal');
      if (modalContent) modalContent.style.cssText = 'display:none !important;';
      
      document.body.style.overflow = '';
      document.body.classList.remove('jdgm-modal-open');

      // Review section પર scroll
      var reviewSection = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg');
      if (reviewSection) {
        reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
});